/**
 * Feature flag resolution. on, off, or beta for a profile id list.
 * Agent regional-vendor browsing stays off. Agent-curated vendors only.
 */

const REGIONAL_VENDORS_ENABLED = false;

function flagKey(value) {
  const key = String(value || '').trim().toLowerCase();
  if (!/^[a-z][a-z0-9_]{1,63}$/.test(key)) return '';
  return key;
}

function flagEnabled(flag, profileId) {
  if (!flag) return false;
  if (flag.state === 'on') return true;
  if (flag.state !== 'beta') return false;
  const ids = Array.isArray(flag.beta_profile_ids) ? flag.beta_profile_ids : [];
  return ids.indexOf(profileId) !== -1;
}

function enabledKeys(flags, profileId) {
  return (flags || []).filter((flag) => flagEnabled(flag, profileId)).map((flag) => flag.key);
}

module.exports = {
  REGIONAL_VENDORS_ENABLED,
  flagKey,
  flagEnabled,
  enabledKeys,
};
